import React from 'react'

import { Badge } from '../../../components/ui'

const statusLabels: Record<string, string> = {
  unknown: 'Unknown',
  sent: 'Sent',
  in_revision: 'In Revision',
  signed: 'Signed',
  on_time: 'On Time',
  late: 'Late',
  prospect: 'Prospect',
  negotiation: 'Negotiation',
  active: 'Active',
  complete: 'Complete',
  cancelled: 'Cancelled',
}

const statusVariants: Record<string, React.ComponentProps<typeof Badge>['variant']> = {
  unknown: 'secondary',
  sent: 'info',
  in_revision: 'warning',
  signed: 'success',
  on_time: 'success',
  late: 'danger',
  prospect: 'info',
  negotiation: 'warning',
  active: 'success',
  complete: 'secondary',
  cancelled: 'danger',
}

export function StatusBadge({ value }: { value?: string | null }) {
  const key = value || 'unknown'
  return (
    <Badge variant={statusVariants[key] || 'secondary'} className="rounded-md">
      {statusLabels[key] || key}
    </Badge>
  )
}

export function SourceBadge({ source }: { source?: string | null }) {
  if (source === 'hubspot') {
    return <Badge variant="warning" className="rounded-md">HubSpot</Badge>
  }
  if (source === 'sow') {
    return <Badge variant="info" className="rounded-md">SOW</Badge>
  }
  return <Badge variant="secondary" className="rounded-md">{source || 'Source'}</Badge>
}

